module.exports = __webpack_public_path__ + "static/media/img-talent-profile-top@3x.13a73c46.png";